export default __webpack_public_path__ + "static/imda20191stprize-8a49cca8cc362fa51925715b60ba9545.jpg";